// Catálogo de módulos y secciones reales de Dexterite, para que un ticket
// diga con precisión dónde ocurrió el bug (ej. "Pedidos" / "Formulario de
// prueba (llenar/revisar)") en vez de solo texto libre. Se actualiza a mano
// cuando se agregan/renombran secciones de la app -- no se deriva
// automáticamente de las rutas porque esta app no usa router, usa un
// state machine por sección (ver AppSidebar.tsx / App.tsx).

import { PRUEBA_NOMBRE_MAP } from "../../constants/pruebasMappings";

export interface Seccion {
  key: string;
  label: string;
}

export interface Modulo {
  key: string;
  label: string;
  secciones: Seccion[];
}

// Una sección por cada prueba real que se puede llenar dentro de un pedido,
// tomada del mismo mapa que usa el resto de la app (App.tsx, filtros de
// PedidosList) -- así queda sincronizado si se agrega/renombra una prueba,
// en vez de mantener una lista de 28 nombres duplicada a mano.
const seccionesFormulariosPrueba: Seccion[] = Object.entries(PRUEBA_NOMBRE_MAP).map(
  ([tipoPrueba, nombre]) => ({ key: `formulario_${tipoPrueba}`, label: nombre }),
);

export const MODULOS: Modulo[] = [
  {
    key: "pedidos",
    label: "Pedidos",
    secciones: [
      { key: "lista", label: "Lista de pedidos" },
      { key: "detalle", label: "Detalle de pedido" },
      { key: "seleccionar_prueba", label: "Agregar prueba a un pedido" },
      { key: "cierre", label: "Cierre de pedido" },
      { key: "reabrir", label: "Reabrir pedido" },
      { key: "reaperturas_pendientes", label: "Reaperturas pendientes de autorización" },
      { key: "documentos", label: "Documentos adjuntos" },
      ...seccionesFormulariosPrueba,
    ],
  },
  {
    key: "lista_pruebas",
    label: "Lista de Pruebas",
    secciones: [{ key: "catalogo", label: "Catálogo de pruebas" }],
  },
  {
    key: "clientes",
    label: "Clientes",
    secciones: [{ key: "lista_edicion", label: "Lista y edición de clientes" }],
  },
  {
    key: "usuarios",
    label: "Usuarios",
    secciones: [{ key: "lista_edicion", label: "Lista y edición de usuarios" }],
  },
  {
    key: "permisos",
    label: "Permisos",
    secciones: [{ key: "matriz", label: "Matriz de permisos" }],
  },
  {
    key: "documentacion",
    label: "Documentación",
    secciones: [{ key: "contenido", label: "Contenido de documentación" }],
  },
  {
    key: "tickets",
    label: "Tickets",
    secciones: [
      { key: "mis_tickets", label: "Mis tickets" },
      { key: "todos", label: "Todos los tickets" },
      { key: "estadisticas", label: "Estadísticas" },
    ],
  },
  {
    key: "otro",
    label: "Otro / no estoy seguro",
    secciones: [],
  },
];
